export default __webpack_public_path__ + "static/media/hawaiizoningatlas-landing.cf140b73.png";